import type {PortfolioAlert} from "@signum/api-contracts";

/** Display grouping only. Every original event and every independent lot is retained. */
export function groupSimulationEvents(alerts: PortfolioAlert[]): PortfolioAlert[][] {
  const groups = new Map<string, PortfolioAlert[]>();
  for (const alert of alerts) {
    const key = [alert.signalDate, alert.issuerCik, alert.issuerSymbol, alert.type, alert.status,
      alert.executionDate ?? ""].join(":");
    const group = groups.get(key);
    if (group) group.push(alert); else groups.set(key, [alert]);
  }
  return [...groups.values()];
}
